export function clearNewsId (key) {
  localStorage.removeItem(key)
}
export function clearNewsPage () {}
export function storeNewsId(newsId, key) {
  let list = localStorage.getItem(key)  
  list = list ? JSON.parse(list) : []
  if (list.includes(newsId)) return
  list.push(newsId)
  localStorage.setItem(key, JSON.stringify(list))
}
export function getColumnName (item) {
  const {columnBeans} = item || {}
  if (columnBeans && columnBeans.length > 0 ) {
    const curColumnItem = columnBeans[0] || {}
    return curColumnItem.name || ''
  }
  return ''
}
export function getAppListImage (item) {
  if (item.attribute) {
    let curImage = item.attribute.listImageUrl
    return curImage || ''
  }
  return ''
}
export function handleClass (item) {
  let isReadedList = localStorage.getItem('isReadedList')
  if (!isReadedList) return ''
  isReadedList = JSON.parse(isReadedList)
  return isReadedList.indexOf(item.newsId) > -1 ? 'is-readed' : ''
}